<template>
  <section>
    <div v-for="d in getTraienrPosts" :key="d.id">
      <div class="ring-1 ring-gray-200 px-4 py-3 mt-4 rounded bg-gray-100">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <Avatar
              :classStr="'h-10 w-10 mr-2'"
              :src="baseUrlSrc(d.thumbnail_url)"
            />
            <p class="capitalize text-md text-gray-dark">
              {{ profile && profile.name }}
              <br />
              <span class="text-xs">
                {{ profile && dateString(profile.created_at) }}
              </span>
            </p>
          </div>
          <div class="flex" v-if="!isAdminView">
            <button class="px-2" @click="handleTrashClick(d.id)">
              <Trash />
            </button>
          </div>
        </div>
        <p class="text-xs mt-4 text-gray-700">
          {{ d.body }}
        </p>
        <div class="flex items-center mt-2">
          <div v-if="d.is_liked" class="flex justify-center">
            <button
              @click="!isAdminView ? handlePostLike(d, false) : ''"
              class="text-xs text-gray-dark"
            >
              <HeartFill />
            </button>
          </div>
          <div v-else class="flex justify-center">
            <button
              @click="!isAdminView ? handlePostLike(d, true) : ''"
              class="text-xs text-gray-dark"
            >
              <Heart />
            </button>
          </div>
          <span class="mr-4 text-xs text-gray-dark ml-1">
            {{ d.like_counter }} Likes</span
          >
          <div class="text-xs text-gray-dark"><Chat /></div>
          <router-link
            :to="{ name: 'TrainerProfilePostView', params: { id: d.id } }"
            class="text-xs text-gray-dark ml-1"
            >{{ d.total_comments }} Comments
          </router-link>
        </div>
      </div>
    </div>
    <Pagination
        v-if="getTraienrPosts && getTraienrPosts.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
  </section>
</template>

<script>
import { Avatar, Pagination } from "@/components/t-components";
import { Chat, Heart, HeartFill, Trash } from "@/components/icons";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Avatar,
    Chat,
    Heart,
    HeartFill,
    Trash,
    Pagination
  },
  props: {
    data: Object,
    handlePostLike: Function,
    getTrainerPostListHandler: Function,
    caliberatepagination: Function,
    isAdminView: Boolean
  },
  data() {
    return {
      profile: [],
    };
  },
  computed: {
    ...mapGetters(["trainerProfile"]),
    getTraienrPosts () {
      return this.data && this.data.data
    },
    currentPage () {
      return this.data && this.data.current_page
    },
    totalPages () {
      return this.data && this.data.last_page
    },
    perPage () {
      return this.data && this.data.per_page
    }
  },
  methods: {
    ...mapActions([
      "trainerPostDelete",
      "getTrainerProfile",
      "postCommentLike",
    ]),
    handlePageChange (page) {
      this.getTrainerPostListHandler({page: page})
    },
    handleTrashClick(id) {
      var c = confirm("Are you sure?");
      if (c) {
        this.trainerPostDelete(id);
        const index = this.getTraienrPosts && this.getTraienrPosts.findIndex((e) => e.id === id);
        if (index !== -1) {
          this.getTraienrPosts && this.getTraienrPosts.splice(index, 1);
          this.caliberatepagination(this.perPage)
        }
      }
    },

    dateString(date) {
      const locales = "en-us";
      const options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return new Date(date).toLocaleDateString(locales, options);
    },
  },
  async created() {
    this.trainerProfile && Object.keys(this.trainerProfile).length ? '' : await this.getTrainerProfile();
    this.profile = this.trainerProfile.profile;
  },
};
</script>